import * as h2Api from '../h2Api'
import { QUIET_SET_LEVEL } from '../observers'

export const TOGGLE_GAMEBOARD_CLASS = 'TOGGLE_GAMEBOARD_CLASS'
export const TOGGLE_AVATAR_MODAL = 'TOGGLE_AVATAR_MODAL'
export const TOGGLE_AVATAR = 'TOGGLE_AVATAR'
export const TOGGLE_BADGE_MODAL = 'TOGGLE_BADGE_MODAL'
export const TOGGLE_TUTORIAL_MODAL = 'TOGGLE_TUTORIAL_MODAL'
export const EDIT_GAMEBOARD_FIELD_CHANGE = 'EDIT_GAMEBOARD_FIELD_CHANGE'
export const EDIT_SAVE_NAME = 'EDIT_SAVE_NAME'
export const ADVANCE_TUTORIAL = 'ADVANCE_TUTORIAL'
export const REGISTER_VIEW = 'REGISTER_VIEW'
export const CLICK_BACKPACK_TAB = 'CLICK_BACKPACK_TAB'
export const TOGGLE_LEVEL_MODAL = 'TOGGLE_LEVEL_MODAL'
export const SET_SPINNER_HOVER = 'SET_SPINNER_HOVER'
export const TOGGLE_HELP_MODAL = 'TOGGLE_HELP_MODAL'
export const TOGGLE_SEARCH_MODAL = 'TOGGLE_SEARCH_MODAL'
export const MARK_INTRO_COMPLETE = 'MARK_INTRO_COMPLETE'
export const API_LEVEL_SET = 'API_LEVEL_SET'
export const UPDATE_NOTES = 'EARLY_UPDATE_NOTES'
export const SAVE_NOTES = 'EARLY_SAVE_NOTES'
export const SAVE_NOTES_INITAL = 'EARLY_SAVE_NOTES_INITIAL'
export const TOGGLE_IS_HOME = 'EARLY_GAME_TOGGLE_IS_HOME'
export const TOGGLE_USER_MODALS_OFF = 'EARLY_GAME_TOGGLE_USER_MODALS_OFF'
export const MARK_LEVEL_UPDATED = 'EARLY_GAME_MARK_LEVEL_UPDATED'
export const SAVE_NOTES_UPDATE = 'SAVE_NOTES_UPDATE'

// -------------------- Action Creators

export const clickBackpackTab = f => dispatch => {
  dispatch({
    type: CLICK_BACKPACK_TAB,
    tabId: f
  })
}

export const pad = number => {
  return number <= 9 ? `0${number}` : number
}

export const toggleAvatarModal = () => dispatch =>
  dispatch({
    type: TOGGLE_AVATAR_MODAL
  })

export const toggleBadgeModal = () => dispatch =>
  dispatch({
    type: TOGGLE_BADGE_MODAL
  })

export const toggleLevelModal = () => dispatch =>
  dispatch({
    type: TOGGLE_LEVEL_MODAL
  })

export const toggleUserModalsOff = () => dispatch => {
  dispatch({
    type: TOGGLE_USER_MODALS_OFF
  })
}

export const toggleHelpModal = () => dispatch => {
  return dispatch(
    h2Api.get(`/documentation/collection/earlyexploration`)({
      type: TOGGLE_HELP_MODAL
    })
  )
}

export const toggleSearchModal = () => dispatch => {
  console.log('toggle modal')
  dispatch({
    type: TOGGLE_SEARCH_MODAL
  })
}

export const toggleTutorialModal = () => dispatch =>
  dispatch({
    type: TOGGLE_TUTORIAL_MODAL
  })

export const advanceTutorial = () => dispatch =>
  dispatch({
    type: ADVANCE_TUTORIAL
  })

export const hoveredSection = s => dispatch =>
  dispatch({
    type: SET_SPINNER_HOVER,
    className: s
  })

export const updateAvatar = f => dispatch => {
  dispatch({
    type: TOGGLE_AVATAR,
    fileId: f
  })
}

export const toggleGameboardState = (cName, cId) => dispatch =>
  dispatch({
    type: TOGGLE_GAMEBOARD_CLASS,
    className: cName,
    componentId: cId
  })

export const changeFormField = fieldValue => dispatch => {
  dispatch({ type: EDIT_GAMEBOARD_FIELD_CHANGE, fieldValue })
}

export const saveName = () => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId
  const name = getState().early.gameboard.userInfo

  return dispatch(
    h2Api.put(`/early/${loadedGameId}/name`, name)({ type: EDIT_SAVE_NAME })
  )
}

export const markSetup = () => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId

  return dispatch(
    h2Api.put(`/early/${loadedGameId}/setup`, {})({ type: MARK_INTRO_COMPLETE })
  )
}

export const updateLevel = (badgeId, level) => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId
  const dataLoaded = getState().early.gameboard.activityLog.dataLoaded

  if (!dataLoaded) {
    return Promise.resolve(false)
  }

  return dispatch(
    h2Api.post(`/early/badge/${loadedGameId}/${badgeId}`, {
      levelId: level
    })({ type: MARK_LEVEL_UPDATED })
  )
}

export const recordLevelProgress = (level, text) => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId
  const postData = {
    levelId: level
  }

  if (!!text && text.length > 0) {
    postData.levelReflection = text
  }

  return dispatch(
    h2Api.post(
      `/early/level/${loadedGameId}`,
      postData
    )({ type: API_LEVEL_SET, details: postData })
  )
}

export const quietUpdateLevel = level => dispatch => {
  return Promise.resolve(dispatch({ type: QUIET_SET_LEVEL, levelId: level }))
}

export const updateNotes = note => dispatch => {
  return Promise.resolve(dispatch({ type: UPDATE_NOTES, notes: note }))
}

export const saveNotes = note => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId

  return dispatch(
    h2Api.post(`/early/${loadedGameId}/notes`, {
      notes: note
    })({ type: SAVE_NOTES_INITAL, notes: note })
  )
}

export const updateNote = (note, noteId) => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId

  return dispatch(
    h2Api.put(`/early/${loadedGameId}/notes/${noteId}`, {
      notes: note
    })({ type: SAVE_NOTES_UPDATE, note, noteId })
  )
}

export const setIsHome = v => dispatch => {
  return dispatch({ type: TOGGLE_IS_HOME, val: v })
}

export const levelProgress = () => (dispatch, getState) => {
  const state = getState()
  const early = state.early
  const ratings = early.backpack.ratings
  const numPathways = early.gameboard.activityLog.pathways.length
  const numPathwaysLiked = ratings.pathways.filter(p => p.rating > 0).length
  const numOccupations = early.gameboard.activityLog.occupations.length
  const numOccupationsLiked = ratings.occupations.filter(p => p.rating > 0).length
  /*
   *    console.log(numPathwaysLiked, numOccupationsLiked, numOccupations, numPathways)
   *    console.log(Math.min(numPathwaysLiked, 3), Math.min(numOccupationsLiked, 5))
   */
  const levelId = state.early.gameboard.progress.levelId
  let currentProgress = 0

  switch (levelId) {
    case 1:
      currentProgress =
        100 * ((Math.min(numPathwaysLiked, 3) + Math.min(numPathways, 5)) / 8) * 0.8

      break
    case 2:
      currentProgress =
        100 *
        ((Math.min(numOccupationsLiked, 5) + Math.min(numOccupations, 10)) / 15) *
        0.8
    default:
      currentProgress = 0
  }

  //    console.log(levelId, currentProgress);
  return Math.min(82, currentProgress)
}

export const calculateTopClusters = (ratings, occCache, pathwayCache) => {
  const clusters = {}
  const clusterRef = {}

  //console.log(ratings, occCache, pathwayCache)
  ratings.occupations
    .filter(i => i.rating > 0)
    .forEach(occ => {
      const o = occCache[occ.onetSoc]

      if (o?.pathway && pathwayCache[o.pathway]) {
        const cl = pathwayCache[o.pathway].cluster
        const v = clusters[cl]

        //            console.log(occ, v)
        clusters[cl] = v ? 1 : v + 1
      }
    })
  ratings.pathways
    .filter(i => i.rating > 0)
    .forEach(occ => {
      const o = pathwayCache[occ.pathwayId]

      // console.log(occ, o)
      if (o) {
        const v = clusters[o.cluster]

        clusters[o.cluster] = v ? 1 : v + 1
      } else {
        console.log(occ.pathwayId, pathwayCache)
      }
    })

  const getSortedKeys = obj => {
    const keys = []

    for (const key in obj) {
      keys.push(key)
    }

    return keys.sort((a, b) => {
      return obj[b] - obj[a]
    })
  }

  return {
    clusters: getSortedKeys(clusters)
  }
}
